import { useCurrentUser } from '@/services/user/user.service';
import { UserTypes } from '@/types/auth.types';
import useLocalUser from '@/utils/useLocalUser/useLocalUser';
import { FC, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

interface RouteByUserTypeProps {
  adminPage?: ReactElement;
  userPage?: ReactElement;
}

const RouteByUserType: FC<RouteByUserTypeProps> = ({ adminPage, userPage }) => {
  const { data } = useCurrentUser(true);
  const { user: localUser } = useLocalUser();
  const aliasInfo = sessionStorage.getItem('aliasInfo');
  const aliasInfoParsed = aliasInfo ? JSON.parse(aliasInfo) : null;
  const userData = aliasInfoParsed || data?.data;
  const user = userData || localUser;

  // admin
  if (user?.type === UserTypes.ADMIN && adminPage !== undefined) return adminPage;
  // if no admin page is specified, don't allow user to go to the route
  if (user?.type === UserTypes.ADMIN && adminPage === undefined) return <Navigate to="/" />;
  // franchisee
  if (user?.type === UserTypes.FRANCHISEE && userPage !== undefined) return userPage;
  // if no user page is specified, don't allow user to go to the route
  if (user?.type === UserTypes.FRANCHISEE && userPage === undefined) return <Navigate to="/" />;
  // if we don't have user type, don't show anything while we fetch it
  return null;
};

export default RouteByUserType;
